export default {
  toggleRewards: {
    activation: {
      physical: {
        title:
          "You're about to activate your <br/>In-Store Loyalty Rewards Program",
        description:
          'Your Loyalty Rewards Program will retain the same rewards rate and refund period.'
      },
      online: {
        title:
          'You’re about to activate your <br/>Online Loyalty Rewards Program',
        description:
          'Your Loyalty Rewards Program will retain the same rewards rate, refund period, and the Loyalty Widget will be automatically activated on your website.'
      },
      primaryButton: 'Confirm activation',
      secondaryButton: 'Cancel activation'
    },
    deactivation: {
      physical: {
        title:
          "You're about to deactivate your <br/>In-Store Loyalty Rewards Program",
        description:
          'Deactivating your In-Store Loyalty Rewards Program will stop the minting of Coins as rewards from card transactions <b>starting from {date}.</b><br/><br/>Tip! Continue to accept Coins at your location for at least 30 days. This will help retain members who have accumulated Coins and are loyal to your brand.'
      },
      online: {
        title:
          "You're about to deactivate your <br/>Online Loyalty Rewards Program",
        description:
          'Deactivating your Online Loyalty Rewards Program will stop the minting of Coins as rewards from your website checkouts <b>starting on {date}.</b><br/><br/>Your Loyalty Widget will automatically be deactivated. Members who have earned Loyalty Rewards will no longer be able to redeem them.'
      },
      primaryButton: 'Cancel deactivation',
      secondaryButton: 'Confirm deactivation'
    },
    success: {
      physical: {
        title: 'In-Store Loyalty Rewards Program activated!',
        description:
          'Your members can now earn Coins every time they make an in-person purchase using a debit or credit card.'
      },
      online: {
        title: 'Online Loyalty Rewards Program activated!',
        description:
          'Your Loyalty Widget is now active and your members can earn Coins every time they make a purchase on your website.'
      },
      primaryButton: 'Got it!',
      secondaryButton: 'Edit Rewards Rate'
    }
  },
  billing: {
    deactivation: {
      title: {
        default: "You're about to deactivate the minting of your Coins",
        delayed: "You're about to disconnect from the Coin Network"
      },
      description: {
        'less-7-days':
          'By deactivating the minting of Coins for Twism, you will still have access to the Coin Network features until the last day of your cycle.<br/>View your <b>7-day cycle plan</b> below:',
        'in-7-days':
          'By deactivating the Coin minting process for Twism, you will no longer participate in the Coin Network:',
        'with-campaign-delayed':
          'Upon disconnection from the Coin Network, your configured campaigns will be immediately deactivated.',
        'without-campaign-delayed':
          'By disconnecting from the Coin Network you will no longer have access to any Coin features. You can reactivate your plan until {date} without minting Coins for Twism.',
        'needs-onboarding-call':
          'By disconnecting from the Coin Network you will no longer have access to any Coin features. You can reactivate your plan before your profile activation without minting Coins for Twism.'
      },
      extraInfo:
        'To disable the distribution of Coins for any of your active campaigns, select the feature you\'d like to edit from the "My Tools" menu.',
      disclaimer:
        'Per the agreed upon terms, your location(s) will continue to accept Coins 60 days after deactivation so loyal members can redeem their accumulated Coins.',
      primaryButton: 'Cancel deactivation',
      secondaryButton: 'Confirm deactivation'
    },
    reactivation: {
      overview: {
        title:
          "You're about to reactivate the minting of your Coins & rejoin the Coin Network",
        description:
          'All of your previous campaigns will become available to members again, and <b style="font-weight: 600;">you\'ll allow Twism to mint 25 Coins per week for each location.</b><br />Check your plan below:'
      },
      overviewMitingDate: {
        title: "You're about to rejoin the Coin Network",
        description:
          'No subscription fees or credit card required!<br/><br/>Twism will mint <b style="font-weight: 600;">25 of your branded Coins per week for each location.</b> Maintaining the number of registered locations ({locations}), your plan will be:'
      },
      cycle: {
        title: 'Your minting cycle will remain the same',
        description:
          'By reactivating the minting of Coins for Twism today, you\'ll retain the same Coin minting cycle. View your <b style="font-weight: 600">7-day cycle plan</b> below:'
      },
      campaigns: {
        title: 'Your configured campaigns',
        description:
          'The following campaigns will be made available. To make any changes, select the feature you\'d like to edit from the "My Tools" menu.'
      },
      primaryButton: {
        getStarted: 'Get Started',
        continue: 'Continue',
        confirm: 'Confirm reactivation'
      },
      secondaryButton: {
        back: 'Back',
        cancel: 'Cancel',
        cancelReactivation: 'Cancel reactivation'
      }
    },
    acceptance: {
      concept: {
        title:
          'Coins are circulating: Engage members by joining the Coin Network',
        description:
          'Watch this video to learn how adding your business to the Coin Network will bring you more members and sales. No credit card required! The Twism Coin Network works for your business unlike any other marketing solution on the planet.'
      },
      charges: {
        title: 'How will my business be charged on Twism?',
        description:
          'Twism does not require cash or a credit card! We truly want to help your business, so instead of you paying us, you\'ll allow us to mint Coins for your business that will then circulate in the Twism network, bringing more business right back to you!<br/><br/>We\'ll mint <b style="font-weight: 600">25 Coins per week for each of your locations.</b> That means the only cost to you is your cost of goods, only when those Coins are redeemed.',
        footerLabel: 'Total:',
        footerValue: '{coins} Coins/week'
      },
      details: {
        title: 'Your business plan on Twism',
        description:
          'No subscription fees or credit card required!<br/><br/>You simply authorize Twism to mint <b style="font-weight: 600;">25 of your branded Coins per week for each location.</b> Twism will distribute these Coins to help promote your business and bring members to you.',
        descriptionWithOnboardingCall:
          'No subscription fees or credit card required!<br/><br/>You simply authorize Twism to mint <b style="font-weight: 600;">25 of your branded Coins per week for each location.</b> Twism will distribute these Coins to help promote your business and bring members to you.<br/><br/><b>Coins will start minting {delayedPeriodDays} days after profile activation.</b>'
      },
      terms: {
        title: 'Terms & Conditions Acceptance',
        description:
          'Twism offers certain aspects of the Services on a subscription basis (a “Subscription”). Twism has the right to charge Merchants a weekly or monthly fee for defined Service levels (the “Fees”) beginning on the eighth day after a Merchant initiates a Subscription and accepts these Merchant Terms (the “Trial Period”). If a Merchant terminates the Services within the Trial Period, Twism shall not charge any Fees. If a Merchant both terminates and reactivates a Subscription before a Trial Period ends, Twism shall charge the Merchant as if no termination had occurred. If a Merchant who has terminated a Subscription reactivates that Subscription after the end of a Trial Period, Twism shall charge Fees immediately without providing an additional Trial Period.<br><br>You hereby authorize Twism to collect and receive Fees in any manner it deems appropriate, in its sole discretion, including by charging a credit card on file or through Twism’s acceptance of Coins redeemable only by you and that are minted by you and delivered to Twism (“Reserve Coins”) totaling 25 Reserve Coins per week, or such other amount as Twism may specify in advance in writing. You acknowledge that Reserve Coin payment functionality may be implemented either automatically (“auto-mint”) or manually directed by you, and that regardless of the method of creating Reserve Coins, you are and at all times shall remain the legal “issuer” of such Reserve Coins for all intents and purposes and shall act as the only business where such Reserve Coins may be redeemed. You acknowledge that Twism has the right to sell or otherwise transfer the Reserve Coins, and the right to set the price of such Reserve Coins, including the right to sell Reserve Coins at a discount determined by Twism in its sole discretion. For the avoidance of doubt, you hereby grant Twism the right to distribute these Coins at its sole discretion, whether as giveaways, promotional items, or for sale at either full value or at a discount, and you acknowledge that Reserve Coins, in Twism’s sole discretion, may be distributed in the same way as other Coins available through the Services or distributed in a different manner by Twism, whether for a price, another form of value, or for free, at its sole discretion. You also acknowledge that Reserve Coins do not expire. You shall honor Reserve Coins that have been distributed or otherwise transferred by Twism, and provide refunds subject to applicable law and these Merchant Terms. If you do not honor Reserve Coins for their full value, Twism reserves the right to seek appropriate recourse on behalf of itself and/or End Users, including but not limited to by charging you through other billing methods or taking legal action. Twism may also suspend your account in its sole discretion.<br><br>Fees are charged until the Subscription and/or your account is terminated by you or Twism pursuant to these <a href="https://twism.com/terms" target="_blank">Merchant Terms</a>.'
      },
      primaryButton: {
        getStarted: 'Get Started',
        continue: 'Next',
        confirm: 'I accept minting Coins for Twism',
        confirmDelayed: 'I agree'
      },
      secondaryButton: {
        back: 'Back',
        cancel: 'Cancel',
        learnMore: 'Learn more'
      }
    },
    delayedPlanOverview: {
      locationsLabel: 'Locations',
      locationsValue: '{locations} active {locationText}',
      mitingCoinsLabel: 'Minting Coins for Twism starts on',
      totalLabel: 'Total:',
      totalValue: '{coins} Coins/week'
    },
    welcome: {
      title: 'Welcome to the Coin Network!',
      description: {
        online:
          'Beginning <b style="font-weight: 600">{date}</b>, Twism will collect 25 of your branded Coins per week per each location. <b style="font-weight: 600">The total amount will be {totalCoins} Coins per week</b> for your {locations}.<br/><br/>Congratulations! You\'ve joined the most powerful network connecting consumers to businesses around the globe! You now have access to a wealth of impactful tools to take your online and in-store business to the next level!',
        physical_online:
          'Beginning <b style="font-weight: 600">{date}</b>, Twism will collect 25 of your branded Coins per week per each location. <b style="font-weight: 600">The total amount will be {totalCoins} Coins per week</b> for your {locations}.<br/><br/>Congratulations! You\'ve joined the most powerful network connecting consumers to businesses around the globe! You now have access to a wealth of impactful tools to take your online and in-store business to the next level!',
        physical:
          'Beginning <b style="font-weight: 600">{date}</b>, Twism will collect 25 of your branded Coins per week per each location. <b style="font-weight: 600">The total amount will be {totalCoins} Coins per week</b> for your {locations}.<br/><br/>Now you have access to features like Welcome Coins, Sell Coins, Loyalty Rewards Program. All of them can empower your business and foster member loyalty, and the best part is, it\'s all with your own branded Coin in circulation!'
      },
      link: 'Learn more about Branded Coins’ power'
    },
    news: {
      title: 'We have <span>news for you!</span>',
      description:
        "As part of Twism's Coin Network, we've introduced updates to enhance your dashboard navigation. Take a quick guided tour to explore what is currently available for your business!",
      btn: 'Start guided tour',
      secondaryBtn: 'Not now'
    },
    returnOnlineOnly: {
      title: 'Your business has returned to online-only operations!',
      description:
        "We've ended your Coin Network plan subscription, making Twism 100% free. Take note of the changes:",
      'item-1': 'Exclusive online-only operations',
      'item-2': 'Coin Network plan subscription discontinued',
      'item-3': 'Enjoy Twism without any costs!',
      extraInfo:
        'You can always add a location and subscribe to the Coin Network Plan again at any time.',
      btn: 'Got it'
    },
    locationBenefits: {
      tipOnCloseTask: {
        online: 'You can add physical locations later in this tab.',
        physical_online: 'You can be part of Coin Network later in this tab.'
      },
      notNowBtnText: 'Not now, maybe later',
      physical_online: {
        title:
          'Join the Coin Network to connect your business to world of consumers!',
        description:
          'The BEST way to reach tens of thousands of potential members, unlock powerful tools, increase sales and create happy repeat business! (No credit card required!)',
        ctaText: `Upgrade Your Plan`
      },
      physical: {
        title:
          'Join the Coin Network to connect your business to world of consumers!',
        description:
          'The BEST way to reach tens of thousands of potential members, unlock powerful tools, increase sales and create happy repeat business! (No credit card required!)',
        ctaText: `Upgrade Your Plan`
      },
      online: {
        title: 'Boost Your Business in Two Ways!!',
        description: `Supercharge your online business by adding a physical location! You'll not only increase foot traffic, you'll be giving your members even more reasons to engage and shop with you!`,
        ctaText: `Add a physical location & Upgrade`
      }
    }
  },
  scheduleOnboadingCall: {
    title: 'Schedule Onboarding Call to Go Live',
    description:
      'To activate your business profile and start engaging with customers, you need to schedule your onboarding meeting.',
    btn: 'Schedule Call',
    closeText: 'Not Now'
  }
};
